import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import HeadingPage from "./Heading";
import useFetchData from "../fetchpostData";
import FillInTheBlanksDraggable from "./FillInTheBlanksDraggable";
import Notification from "./Notification";
import SpacingBox from "./Spacing";
import ScoreCardForReading from "./ScoreBoxForReadingSection";
import ScoreBoxForDoubleAnswer from "./ResponseBoxDoubleType";
import Timers from "../PageComponent/Timers";

export default function ReadingFillInTheBlanksPage() {
  const { title } = useParams();
  const section = "fillintheblank";
  const practiceItemId = title;

  const post = useFetchData(section, title);
  const [originalWords, setOriginalWords] = useState("");
  const [Mcq_Question, setMcq_Question] = useState("");
  const [Title, setTitle] = useState("");
  const [paraTitle, setParaTitle] = useState("");
  const [Options, setOptions] = useState([]);
  const [isAttempted, setIsAttempted] = useState(false);
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationType, setNotificationType] = useState("");
  const [loading, setLoading] = useState(false);
  const [submittedOptions, setSubmittedOptions] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [savedPractice, setSavedPractice] = useState(null);

  useEffect(() => {
    console.log("Post Data :", post);

    if (post && post.question) {
      setOriginalWords(post.question);
      setMcq_Question(post.question_mcq);
      setTitle(post.q_title);
      setParaTitle(post.title);
      setOptions(post.option.map((option) => option.options));
    }
  }, [post]);

  const savePractice = async (practiceData) => {
    try {
      const response = await fetch("/api/save-readingfillintheblanks", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(practiceData),
      });

      if (!response.ok) {
        throw new Error("Failed to save practice data");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSubmitted(true);

    const answer = submittedOptions.join(", ");
    const practiceType = section;

    const practiceData = {
      practiceType,
      practiceItemId,
      response: {
        questionId: practiceItemId,
        answer,
        isAttempted,
      },
    };
    console.log("practiceData:", practiceData);
    try {
      const result = await savePractice(practiceData);
      console.log("Practice data saved:", result);
      setMessage("Practice data saved successfully!");
      setNotificationType("success");
      setShowNotification(true);
      setSavedPractice(result);

      setTimeout(() => {
        setIsAttempted(true);
        setLoading(false);
      }, 2000);
    } catch (error) {
      console.error("Error saving practice data:", error);
      setMessage("Failed to save practice data.");
      setNotificationType("error");
      setShowNotification(true);
      setLoading(false);
      setSubmitted(false);
    }
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  const handleRetake = () => {
    setSubmitted(false);
    setIsAttempted(false);
    setSubmittedOptions([]);
  };

  const handleIsAttempted = (isAttemptedValue) => {
    setIsAttempted(isAttemptedValue);
  };

  console.log("submittedOptions", submittedOptions);

  const attemptedStatus = isAttempted ? "Attempted" : "Not Attempted";

  return (
    <div>
      <Headerdash />
      <Sidebar />
      <div className="relative md:left-72 left-0 md:ml-3 top-28 bg-gray-100 h-auto w-full md:w-[1150px] rounded-sm p-4 ">
        <HeadingPage
          title={Title}
          timer={<Timers initialSeconds={0} />} // Use the Timer component here
          difficulty="Medium"
          attempted={attemptedStatus}
          para={paraTitle}
        />
        <h3 class="mx-auto px-5 text-base sm:text-lg md:text-xl lg:text-base font-semibold leading-relaxed">
          In the text below some words are missing. Drag words from the text box
          below to the appropriate place in the text. To undo an answer choice,
          drag the word back to the box below the text.
        </h3>
        <div className="mb-6">
          <FillInTheBlanksDraggable
            sentence={originalWords}
            options={Options}
            submitted={submitted}
            onOptionsChange={setSubmittedOptions}
          />
        </div>

        <div className="flex space-x-4 mt-4">
          <button
            className="bg-blue-800 hover:bg-blue-500 text-white font-semibold py-1 px-4 ml-5 rounded-sm"
            onClick={handleSubmit}
            disabled={submitted}
          >
            <span className="flex items-center justify-center">
              {loading ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  <span>Submitting...</span>
                </>
              ) : (
                "Submit"
              )}
            </span>
          </button>

          {submitted && (
            <button
              type="button"
              onClick={handleRetake}
              className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-1 px-4 rounded-sm"
            >
              Retake
            </button>
          )}
        </div>

        {submitted ? (
          <>
            <div className="flex items-center justify-center h-72 bg-gray-100">
              <ScoreCardForReading
                score={savedPractice?.savedResponse.totalScore}
                maxScore={savedPractice?.savedResponse.optionResponses.length}
              />
            </div>
          </>
        ) : null}
        <ScoreBoxForDoubleAnswer
          originalWords={originalWords}
          practiceItemId={practiceItemId}
          onIsAttempted={handleIsAttempted}
        />

        {showNotification && (
          <Notification
            message={message}
            type={notificationType}
            onClose={handleCloseNotification}
          />
        )}
        <SpacingBox />
      </div>
    </div>
  );
}
